import { baseApi } from '@shared/api/baseApi';
export interface BestSeller { productId: string; salesCount: number }
export const bestSellersApi = baseApi.injectEndpoints({ endpoints: builder => ({
  getBestSellers: builder.query<BestSeller[], void>({
    query: () => '/marketplace/best-sellers',
    transformResponse: (response: { products: BestSeller[] }) => response.products,
    providesTags: ['Product'],
  }),
}) });
export const { useGetBestSellersQuery } = bestSellersApi;
